<div class="pnf h-100">
  <div class="container h-100">
    <div class="d-flex align-items-center justify-content-center h-100">
      <div class="notfound">
        <div class="notfound-404 text-center">
          <h3 i18n>Page not Found</h3>
          <img
            alt="Not Found"
            class="img404 img-fluid"
            src="{{ decoration }}" />
          <h2 i18n>
            We regret to inform you that the page you are looking for is not
            available.
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>
